var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"loading",attrs:{"tabindex":"0","href":"."},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('span',[_vm._t("default")],2),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }